<template>
  <div class="modal-overflow">
    <div class="card-body d-flex" style="min-height: 300px">

<!--      Left side -->
      <div class="col col-7 d-flex flex-column">
        <div class="mb-3">
          <h5 class="mb-1">{{ data.inspectionType }}</h5>
          <template v-if="data.reinspection">
            <p>
              <strong>Reinspection</strong>
              (Previous Inspector: {{
                data.mostRecentAvailableInspectorForReinspection
                  ? data.mostRecentAvailableInspectorForReinspection.name
                  : "None Available"
              }})
            </p>
          </template>
        </div>
        <div class="d-flex align-items-start mb-3">
          <h6 class="mt-1" style="min-width:100px;">Project:</h6>
          <a @click.prevent="openViewProjectModal(data.project.id)" href="#">
            {{ data.projectName }}
          </a>
        </div>
        <div class="d-flex align-items-start mb-3">
          <h6 class="mt-1" style="min-width:100px;">Job:</h6>
          <a @click.prevent="openEditJobModal(data.job.id)" href="#">
            {{ data.job.name }}
          </a>
        </div>
        <div class="d-flex align-items-start">
          <h6 class="mt-1" style="min-width:100px; max-width:100px;">Assigned Inspector:</h6>
          <p>
            <strong>{{ data.assignedInspector.name }}</strong>
            <template v-if="data.manuallyAssignedInspector && data.assignedInspector.id === data.manuallyAssignedInspector.id">
              &nbsp;
              (Manually Assigned)
            </template>
            <template v-if="data.mostRecentAvailableInspectorForReinspection && data.assignedInspector.id === data.mostRecentAvailableInspectorForReinspection.id">
              (Previous Inspector)
            </template>
          </p>
        </div>
      </div>

<!--      Right Side -->
      <div class="d-flex flex-column col-5 justify-content-between">
        <div class="d-flex flex-column">
          <h6>Reassign Inspection</h6>
          <div class="d-flex mb-3 justify-content-between">
            <inspector-select :assigned-inspector="assignedInspector"
                              @inspector-changed="handleInspectorChanged"
                              class="w-100"/>
            <el-button @click="unassignInspection" type="danger" style="margin-left:10px; padding:5px; width:40px;"> X </el-button>
          </div>
        </div>
        <el-button @click="saveAssignment" class="w-50 align-self-end" type="primary" :disabled="saving">
          <template v-if="!saving">
            Save
          </template>
          <template v-else>
            Saving ...
          </template>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import InspectorSelect from '@/components/Dashboard/Views/InspectorRouting/InspectorSelect.vue'

export default {
  components: {
    InspectorSelect,
  },
  props: ['data'],
  computed: {
    ...mapGetters ({
      inspectorsForSelect: 'inspectorRouting/inspectorsForSelect'
    }),
  },
  data() {
    return {
      assignedInspector: {},
      saving: false
    }
  },
  methods: {
    handleInspectorChanged(inspector) {
      this.assignedInspector = inspector
    },
    saveAssignment() {
      this.saving = true
      const payload = {
        'inspectionId': this.data.ptracTaskId,
        'assignedInspector': this.assignedInspector
      }
      this.$store.commit('inspectorRouting/reassignInspection', payload)
      this.$eventHub.$emit('assignmentChanged', this.data)
      this.$emit('close')
    },
    openViewProjectModal(id) {
      this.$eventHub.$emit('show-modal-2', "View Project", {id: id}, '1000px')
    },
    openEditJobModal(id) {
      this.$eventHub.$emit('show-modal-3', "View Job", {id: id}, '1000px')
    },

    unassignInspection() {
      this.assignedInspector = this.inspectorsForSelect[0]
    }
  },
  beforeMount() {
    this.assignedInspector = this.inspectorsForSelect.find(user => user.value === this.data.assignedInspector.id)
  },
  mounted() {
    this.$on('inspectorChanged', (inspector) => {
      this.assignedInspector = inspector
    })
  },
  beforeDestroy() {
    this.assignedInspector = {}
  }
}
</script>
